module.exports = __webpack_public_path__ + "img/support.ba5a0732.svg";